import { GroupModel } from '@em/models/restapi/Group.Model';
import { CollectionModel } from '@shared/models/restapi/Collection.Model';

export class GroupCollectionModel extends CollectionModel<GroupModel> {
    public constructor() {
        super(GroupModel);
    }
}
